/**
 * @file 初期モーダル終了
 *
 */
'use strict';

/**
 * @classname SetComplete
 * @classdesc 初期モーダル終了
 */
export default class SetComplete {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log('SetComplete.constructor');
		this._$e = $e;
		this._controller = controller;
		$e.on('click', (e) => this.onClick(e));
	};

	/**
	 * クリックのコールバック
	 *
	 * @memberof SetComplete
	 * @return {undefined}
	 */
	onClick(e){
		console.log('SetComplete.onClick');
		e.preventDefault();
		window.localStorage.setItem('init', 'complete');
		if(this._$e.hasClass('anchor--regist-password')) {
			this._controller._$modal.hide();
			this._controller._$passportRegistModal.show();
		}else{
			const url = this._$e.attr('href');
			location.href = url;
		}
	}
}
